import "./footer.css";
import { useNavigate } from "react-router-dom";

export default function Footer() {
  return (
    <>
      <div className="section-full-w-row footer-section">
        <div className="section-boxed-w-row">
          <div className="footer-container">
            <div className="footer-container-main">
              <div className="footer-4">
                <div className="footer-4-header">
                  {/* <p  className='quick-link-heading'>CONTACT INFO</p> */}
                </div>
                <div className="footer-4-body">
                  <a
                    href="https://hudsontransition.com/"
                    target="_blank"
                    className="quick-links-sub contact-info"
                  >
                    <i className="ri-copyright-fill"></i>
                    <span> 2026 hudsontransitions.com</span>
                  </a>
                  <a
                    href="tel:8888036131"
                    className="quick-links-sub contact-info"
                  >
                    <i className="ri-smartphone-line"></i>
                    <span>888.803.6131</span>
                  </a>
                  <a
                    href="mailto:info@hudsontransitions.com"
                    className="quick-links-sub contact-info"
                  >
                    <i className="ri-mail-line"></i>
                    <span>info@hudsontransitions.com</span>
                  </a>
                </div>
              </div>
              <div className="footer-5">
                <div className="footer-5-header">
                  {/* <p  className='quick-link-heading'>FOLLOW US ON</p> */}
                </div>
                <div className="footer-5-body">
                  <a
                    href="https://www.facebook.com/hudsontransitions"
                    target="_blank"
                    className="social-links"
                  >
                    <i className="ri-facebook-fill"></i>
                  </a>
                  <a
                    href="https://www.linkedin.com/company/hudson-transition-partners-inc/"
                    target="_blank"
                    className="social-links"
                  >
                    <i className="ri-linkedin-box-line"></i>
                  </a>
                </div>

                <div className="footer-5-body" style={{ marginTop: "20px" }}>
                  <a
                    href="https://hudsontransition.com/privacy-policy/"
                    target="_blank"
                    className="quick-links-sub"
                  >
                    Privacy Policy
                  </a>
                  <a href="#" target="_blank" className="quick-links-sub">
                    {" "}
                    |{" "}
                  </a>
                  <a
                    href="https://hudsontransition.com/terms-conditions/"
                    target="_blank"
                    className="quick-links-sub"
                  >
                    Terms and Conditions
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
